// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-user-block-conatiner {
  display: flex;
  position: relative;
  column-gap: 10px;
  justify-content: flex-end;
  font-family: "Proxima Nova", sans-serif;
  -webkit-user-select: none;
          user-select: none;
  max-width: 140px;
  width: 100%;
}
.header-user-block-conatiner.simple {
  max-width: none !important;
}
.header-user-block-conatiner .pill-menu {
  background-color: #5F5F5F;
  border-radius: 25px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 14px;
  width: 94px;
  height: -moz-fit-content;
  height: fit-content;
  margin-left: 35px;
}
.header-user-block-conatiner .pill-menu svg {
  transition: 0.3s ease-in-out;
  transform: rotate(0deg);
}
.header-user-block-conatiner .pill-menu.active > svg {
  transform: rotate(180deg);
}
.header-user-block-conatiner .photo {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 100%;
}
.header-user-block-conatiner .menu {
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background-color: #F9F9F9;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.header-user-block-conatiner .menu:hover {
  opacity: 0.75;
}
.header-user-block-conatiner .menu.active {
  background-color: var(--primary-color-1);
}
.header-user-block-conatiner .indicator {
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}
.header-user-block-conatiner .indicator.agent {
  background-color: #FEF7DE;
}
.header-user-block-conatiner .indicator.buyer.Q {
  background-color: #FEF7DE;
}
.header-user-block-conatiner .indicator.buyer.F {
  background-color: #F9F9F9;
}
.header-user-block-conatiner .indicator.buyer.H {
  background-color: #F3F3F3;
}
.header-user-block-conatiner .indicator.mortgage_broker {
  background-color: #E7EEE6;
}
.header-user-block-conatiner .profile-menu {
  width: 264px;
  height: auto;
  background-color: white;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1490196078);
  border-radius: 16px;
  position: absolute;
  z-index: 99;
  right: 0;
  top: 55px;
  padding: 16px 11px;
  cursor: default;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease-in-out 0s;
  flex-direction: column;
}
.header-user-block-conatiner .profile-menu.remove {
  opacity: 0;
  visibility: hidden;
  animation: slideup-user-nav 0.3s;
  transition: all 0.3s ease-in-out 0s;
}
.header-user-block-conatiner .profile-menu.remove .buyer-agent-info {
  opacity: 0;
}
.header-user-block-conatiner .profile-menu.show {
  animation: slidedown-user-nav 0.3s;
  animation-timing-function: ease-in-out;
  visibility: visible;
  opacity: 1;
}
.header-user-block-conatiner .profile-menu .profile-card {
  display: flex;
  column-gap: 13px;
  border-radius: 8px;
  background-color: #F9F9F9;
  padding: 8px 3px;
}
.header-user-block-conatiner .profile-menu .profile-card img {
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 100%;
}
.header-user-block-conatiner .profile-menu .profile-card > div {
  display: flex;
  flex-direction: column;
  row-gap: 4;
  justify-content: center;
}
.header-user-block-conatiner .profile-menu .profile-card > div p {
  font-size: 12px;
  font-weight: 700;
  margin: 0;
}
.header-user-block-conatiner .profile-menu .profile-card > div span {
  font-size: 10px;
  font-weight: 400;
  color: #5F5F5F;
}
.header-user-block-conatiner .profile-menu .menu-items {
  display: flex;
  flex-direction: column;
  padding: 0 8px;
  row-gap: 3px;
}
.header-user-block-conatiner .profile-menu .menu-items li {
  font-size: 12px;
  font-weight: 700;
  padding: 6px 12px;
  transition: 0.2s ease-in-out;
  background-color: white;
  color: var(--secondary-color-1);
  cursor: pointer;
  border-radius: 6px;
  line-height: 16px;
}
.header-user-block-conatiner .profile-menu .menu-items li:hover {
  color: white;
  background-color: var(--primary-color-1);
}
.header-user-block-conatiner .profile-menu .menu-items li.logout:hover {
  background-color: #F04545;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .header-user-block-conatiner .photo {
    width: 25px;
    height: 25px;
  }
  .header-user-block-conatiner .menu {
    height: 25px;
    width: 25px;
  }
  .header-user-block-conatiner .menu > svg {
    width: 12px;
    height: 12px;
  }
  .header-user-block-conatiner .indicator {
    height: 25px;
    width: 25px;
  }
  .header-user-block-conatiner .indicator > svg {
    width: 12px;
    height: 12px;
  }
  .header-user-block-conatiner .pill-menu {
    width: 84px;
    margin-left: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/HeaderUserBlock/headerUserBlock.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,uCAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gBAAA;EACA,WAAA;AADJ;AAEI;EACI,0BAAA;AAAR;AAEI;EACI,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,wBAAA;EAAA,mBAAA;EACA,iBAAA;AAAR;AACQ;EACI,4BAAA;EACA,uBAAA;AACZ;AACQ;EACI,yBAAA;AACZ;AAEI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAAR;AAGI;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,4BAAA;AADR;AAGQ;EACI,aAAA;AADZ;AAIQ;EACI,wCAAA;AAFZ;AAMI;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAJR;AAMQ;EACI,yBAAA;AAJZ;AAQY;EACI,yBAAA;AANhB;AASY;EACI,yBAAA;AAPhB;AAUY;EACI,yBAAA;AARhB;AAYQ;EACI,yBAAA;AAVZ;AAcI;EACI,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mDAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,mCAAA;EACA,sBAAA;AAZR;AAcQ;EACI,UAAA;EACA,kBAAA;EACA,gCAAA;EACA,mCAAA;AAZZ;AAcY;EACI,UAAA;AAZhB;AAgBQ;EACI,kCAAA;EACA,sCAAA;EACA,mBAAA;EACA,UAAA;AAdZ;AAiBQ;EACI,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AAfZ;AAgBY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAdhB;AAgBY;EACI,aAAA;EACA,sBAAA;EACA,UAAA;EACA,uBAAA;AAdhB;AAegB;EACI,eAAA;EACA,gBAAA;EACA,SAAA;AAbpB;AAegB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAbpB;AAiBQ;EACI,aAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;AAfZ;AAgBY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,uBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAdhB;AAegB;EACI,YAAA;EACA,wCAAA;AAbpB;AAegB;EACI,yBAAA;AAbpB;;AC/JY;EDqLJ;IACI,WAAA;IACA,YAAA;EAlBV;EAqBM;IACI,YAAA;IACA,WAAA;EAnBV;EAoBU;IACI,WAAA;IACA,YAAA;EAlBd;EAqBM;IACI,YAAA;IACA,WAAA;EAnBV;EAoBU;IACI,WAAA;IACA,YAAA;EAlBd;EAqBM;IACI,WAAA;IACA,gBAAA;EAnBV;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\n\n.header-user-block-conatiner {\n    display: flex;\n    position: relative;\n    column-gap: 10px;\n    justify-content: flex-end;\n    font-family: 'Proxima Nova', sans-serif;\n    user-select: none;\n    max-width: 140px;\n    width: 100%;\n    &.simple {\n        max-width: none !important;\n    }\n    .pill-menu {\n        background-color: #5F5F5F;\n        border-radius: 25px;\n        padding: 5px;\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        column-gap: 14px;\n        width: 94px;\n        height: fit-content;\n        margin-left: 35px;\n        svg {\n            transition: .3s ease-in-out;\n            transform: rotate(0deg);\n        }\n        &.active > svg {\n            transform: rotate(180deg);\n        }\n    }\n    .photo {\n        width: 40px;\n        height: 40px;\n        object-fit: cover;\n        border-radius: 100%;\n    }\n\n    .menu {\n        height: 40px;\n        width: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 10px;\n        background-color: #F9F9F9;\n        cursor: pointer;\n        transition: .2s ease-in-out;\n\n        &:hover {\n            opacity: .75;\n        }\n\n        &.active {\n            background-color: var(--primary-color-1);\n        }\n    }\n\n    .indicator {\n        height: 40px;\n        width: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 10px;\n\n        &.agent {\n            background-color: #FEF7DE;\n        }\n\n        &.buyer {\n            &.Q {\n                background-color: #FEF7DE;\n            }\n\n            &.F {\n                background-color: #F9F9F9;\n            }\n\n            &.H {\n                background-color: #F3F3F3;\n            }\n        }\n\n        &.mortgage_broker {\n            background-color: #E7EEE6;\n        }\n    }\n\n    .profile-menu {\n        width: 264px;\n        height: auto;\n        background-color: white;\n        box-shadow: 0px 0px 2px #00000026;\n        border-radius: 16px;\n        position: absolute;\n        z-index: 99;\n        right: 0;\n        top: 55px;\n        padding: 16px 11px;\n        cursor: default;\n        opacity: 0;\n        visibility: hidden;\n        transition: all 0.3s ease-in-out 0s;\n        flex-direction: column;\n\n        &.remove {\n            opacity: 0;\n            visibility: hidden;\n            animation: slideup-user-nav .3s;\n            transition: all 0.3s ease-in-out 0s;\n\n            .buyer-agent-info {\n                opacity: 0;\n            }\n        }\n\n        &.show {\n            animation: slidedown-user-nav .3s;\n            animation-timing-function: ease-in-out;\n            visibility: visible;\n            opacity: 1;\n        }\n\n        .profile-card {\n            display: flex;\n            column-gap: 13px;\n            border-radius: 8px;\n            background-color: #F9F9F9;\n            padding: 8px 3px;\n            img {\n                width: 30px;\n                height: 30px;\n                object-fit: cover;\n                border-radius: 100%;\n            }\n            > div {\n                display: flex;\n                flex-direction: column;\n                row-gap: 4;\n                justify-content: center;\n                p {\n                    font-size: 12px;\n                    font-weight: 700;\n                    margin: 0;\n                }\n                span {\n                    font-size: 10px;\n                    font-weight: 400;\n                    color: #5F5F5F;\n                }\n            }\n        }\n        .menu-items {\n            display: flex;\n            flex-direction: column;\n            padding: 0 8px;\n            row-gap: 3px;\n            li {\n                font-size: 12px;\n                font-weight: 700;\n                padding: 6px 12px;\n                transition: .2s ease-in-out;\n                background-color: white;\n                color: var(--secondary-color-1);\n                cursor: pointer;\n                border-radius: 6px;\n                line-height: 16px;\n                &:hover {\n                    color: white;\n                    background-color: var(--primary-color-1);\n                }\n                &.logout:hover {\n                    background-color: #F04545;\n                }\n            }    \n        }\n    }\n}\n\n@include media(mobile) {\n    .header-user-block-conatiner {\n        .photo {\n            width: 25px;\n            height: 25px;\n        }\n    \n        .menu {\n            height: 25px;\n            width: 25px;\n            > svg {\n                width: 12px;\n                height: 12px;\n            }\n        }\n        .indicator {\n            height: 25px;\n            width: 25px;\n            > svg {\n                width: 12px;\n                height: 12px;\n            }\n        }\n        .pill-menu {\n            width: 84px;\n            margin-left: 0px;\n        }\n    }\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
